@if (mission) {
  <div class="page">
    <div class="page-toolbar">
      <div class="page-toolbar__start">
        <div>
          <h1 class="page-title">{{ 'MISSION.CONFIGURATION_TITLE' | translate }}</h1>
          <div class="page-subtitle">{{ 'MISSION.CONFIGURATION_SUBTITLE' | translate }}</div>
        </div>
      </div>
    </div>

    <div class="card sections">
      <button type="button" class="section" (click)="navigateToTeam()">
        <span class="section__icon"><ng-icon name="heroUserGroup" size="22"/></span>
        <span class="section__label">
          <span class="section__name">{{ 'MISSION.TEAM' | translate }}</span>
          <span class="section__meta">{{ 'MISSION.COUNT.MEMBERS' | translate: { count: getTeamCount() } }}</span>
        </span>
        <span class="status-pill" [ngClass]="getStatusClass(mission.teamstatus, false)">{{ mission.teamstatus | statusLabel | async }}</span>
        <ng-icon class="section__chevron" name="heroChevronRight" size="18"/>
      </button>

      <button type="button" class="section" (click)="navigateToProduct()">
        <span class="section__icon"><ng-icon name="heroTruck" size="22"/></span>
        <span class="section__label">
          <span class="section__name">{{ 'MISSION.PRODUCT' | translate }}</span>
          <span class="section__meta">{{ 'MISSION.COUNT.CONTAINERS' | translate: { count: getProductCount() } }}</span>
        </span>
        <span class="status-pill" [ngClass]="getStatusClass(mission.productstatus, true)">{{ mission.productstatus | statusLabel | async }}</span>
        <ng-icon class="section__chevron" name="heroChevronRight" size="18"/>
      </button>

      <button type="button" class="section" (click)="navigateToMaterial()">
        <span class="section__icon"><ng-icon name="heroWrenchScrewdriver" size="22"/></span>
        <span class="section__label">
          <span class="section__name">{{ 'MISSION.MATERIAL' | translate }}</span>
          <span class="section__meta">{{ 'MISSION.COUNT.EQUIPMENTS' | translate: { count: getMaterialCount() } }}</span>
        </span>
        <span class="status-pill" [ngClass]="getStatusClass(mission.materialstatus, true)">{{ mission.materialstatus | statusLabel | async }}</span>
        <ng-icon class="section__chevron" name="heroChevronRight" size="18"/>
      </button>

      <button type="button" class="section" (click)="navigateToSupport()">
        <span class="section__icon"><ng-icon name="heroLifebuoy" size="22"/></span>
        <span class="section__label">
          <span class="section__name">{{ 'MISSION.SUPPORT' | translate }}</span>
          <span class="section__meta">{{ 'MISSION.COUNT.MEMBERS' | translate: { count: getSupportCount() } }}</span>
        </span>
        <span class="status-pill" [ngClass]="getStatusClass(mission.supportstatus, false)">{{ mission.supportstatus | statusLabel | async }}</span>
        <ng-icon class="section__chevron" name="heroChevronRight" size="18"/>
      </button>

      <button type="button" class="section" (click)="navigateToParticipant()">
        <span class="section__icon"><ng-icon name="heroIdentification" size="22"/></span>
        <span class="section__label">
          <span class="section__name">{{ 'MISSION.PARTICIPANTS' | translate }}</span>
          <span class="section__meta">{{ 'MISSION.COUNT.ATTENDEES' | translate: { count: getParticipantCount() } }}</span>
        </span>
        <span class="status-pill" [ngClass]="getParticipantsStatusClass()">{{ getParticipantsStatus() | statusLabel | async }}</span>
        <ng-icon class="section__chevron" name="heroChevronRight" size="18"/>
      </button>
    </div>
  </div>
}
